// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { MenuList, MenuItem } from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal Dependencies
import PoiDetailsRouter from './detailsRouter';
import apiService from '../../services.js/apiService';
import { IsEmpty } from '../../common/checks';
import PoiHeader from './header';

const PoiDetails = (props) => {
  const [poiInView, setPoiInView] = useState(null);

  useEffect(() => {
    // fetch the poi data
    async function fetchPoiData() {
      try {
        const poi = await apiService.getPoi(props.match.params.id);
        if (poi) {
          setPoiInView(poi);
        } else {
          toast.error('POI not found');
        }
      } catch (error) {
        toast.error(error.message || 'An unexpected error has occurred');
      }
    }
    fetchPoiData();
  }, [props.match.params.id]);

  return IsEmpty(poiInView) ? <></> : (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-12">
          <PoiHeader id={props.match.params.id} />
        </div>
      </div>

      <div className="row">
        <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
          <MenuList>
            <Link to={`${props.match.url}`}><span><MenuItem>Info</MenuItem></span></Link>
            <Link to={`${props.match.url}/photos`}><span><MenuItem>Photos</MenuItem></span></Link>
            <Link to={`${props.match.url}/openinghours`}><span><MenuItem>Opening Hours</MenuItem></span></Link>
          </MenuList>
        </div>
        <div className="col-md-10 card-left">
          <PoiDetailsRouter match={props.match} />
        </div>
      </div>
    </div>
  );
};

PoiDetails.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default PoiDetails;
